import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {NgxSpinnerService} from 'ngx-spinner';
import * as moment from 'jalali-moment';
import {ActivatedRoute} from '@angular/router';
import {take} from 'rxjs/internal/operators';
import {ASSIGN_CUSTOMER_USER} from "../../app.constants";
import {Customer, ICustomer} from "../../shared/model/customer.model";
import {IUser, User} from "../../core/user/user.model";
import {IStateCity, StateCity} from "../../shared/model/stateCity.model";
import {IEmployee} from "../../shared/model/employee.model";
import {IDepartment} from "../../shared/model/department.model";
import {IFieldActivity} from "../../shared/model/field-activity.model";
import {IIntroduction} from "../../shared/model/introduction.model";
import {IConnector} from "../../shared/model/connector.model";
import {CustomerService} from "../../entities/customer/customer.service";
import {FieldActivityService} from "../../entities/field-activity/field-activity.service";
import {IntroductionService} from "../../entities/introduction/introduction.service";
import {ConnectorService} from "../../entities/connector/connector.service";
import {DepartmentService} from "../../entities/department/department.service";
import {EmployeeService} from "../../core/employee/employee.service";
import {UserService} from "../../core/user/user.service";
import {AccountService} from "../../singelton/account.service";
import {PhoneSearchComponent} from "../../entities/phone/phone-search.component";
import {CustomerAddRapidComponent} from "../../entities/customer/customer-add-rapid.component";
import {OrderAddComponent} from "../../entities/order/order-add.component";
import {CustomerAssignUserDialogComponent} from "../../entities/customer/customer-assign-user-dialog.component";
import {ICustomerExcel} from "../../shared/model/customer_excel.model";
import {CustomerAdvancedSearchComponent} from "../../entities/customer/customer-advanced-search.component";
import { Subject } from "rxjs";

@Component({
  selector: 'app-advanced-search-customer',
  templateUrl: './advanced-search-customer.component.html',
  // styleUrls: ['./advanced-search-customer.component.scss']
})
export class AdvancedSearchCustomerComponent implements OnInit {
  // @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  @Input() term;
  @Input() resetFormSubject: Subject<boolean> = new Subject<boolean>();

  width: any = '';
  class: any;
  // business_tyep: any = BUSINESS_TYPE;
  show_assign_customer_user: any = ASSIGN_CUSTOMER_USER;
  customerSearch: Customer = new Customer;
  dateObject: any;
  dateObject_to: any;
  currentAccount: any;
  customers: ICustomer[];
  customers_excel: ICustomer[];
  error: any;
  success: any;
  userParam: any;
  // eventSubscriber: Subscription;
  routeData: any;
  links: any;
  totalItems: any;
  totalItems_customer: any;
  queryCount: any;
  itemsPerPage: any;
  page: any = 1;
  predicate: any;
  previousPage: any;
  reverse: any;
  customer: ICustomer = new Customer();
  users: User[];
  user: IUser = new User();

  pageCount: any;
  start: any;
  end: any;

  actionDate_from: any;
  actionDate_to: any;
  actionDate_startDate: any;
  deadline_days: any;

  cityList: StateCity[];
  stateList: StateCity[];

  employees: IEmployee[];
  fieldActivities: IFieldActivity[];
  departments: IDepartment[];
  introductions: IIntroduction[];
  connectors: IConnector[];
  selectedBox = false;
  selectedAllBox = false;
  login: any;

  closeResult: string;
  customersSelected: any[] = [];

  keyword = 'title';

  selectEvent(item) {
    alert(' in select event ==' + item.id);
  }

  onChangeSearch(val: string) {
    this.customer.title = val;
    this.search(this.page, true);
  }

  onFocused(e) {
  }

  constructor(protected customerService: CustomerService, private modalService: NgbModal, public accountService: AccountService, private router: Router,
              protected fieldActivityService: FieldActivityService,
              protected departmentService: DepartmentService,
              protected introductionService: IntroductionService,
              protected connectorService: ConnectorService,
              protected employeeService: EmployeeService,
              protected userService: UserService,
              private toastr: ToastrService,
              protected activatedRoute: ActivatedRoute,
              private spinner: NgxSpinnerService) {
    this.itemsPerPage = 3;
    this.page = 1;
    this.predicate = 'title';
    this.reverse = 'asc';
    this.customer.status = 'all';
    this.accountService.identity().then(d => {
      this.login = d.login;
    });

    if (this.activatedRoute.snapshot.params['page']) {
      this.page = this.activatedRoute.snapshot.params['page'];
    } else {
      this.page = 1;
    }

    if (this.activatedRoute.snapshot.params['predicate']) {
      this.predicate = this.activatedRoute.snapshot.params['predicate'];
    } else {
      this.predicate = 'title';
    }

    if (this.activatedRoute.snapshot.params['reverse']) {
      this.reverse = this.activatedRoute.snapshot.params['reverse'];
    } else {
      this.reverse = 'desc';
    }

    if (this.activatedRoute.snapshot.params['createdBy']) {
      this.customer.createdBy = this.activatedRoute.snapshot.params['createdBy'];
    }
    if (this.activatedRoute.snapshot.params['customer']) {
      this.customer.title = this.activatedRoute.snapshot.params['customer'];
    }
    if (this.activatedRoute.snapshot.params['status']) {
      this.customer.status = this.activatedRoute.snapshot.params['status'];
    }
    if (this.activatedRoute.snapshot.params['state']) {
      this.customer.state = this.activatedRoute.snapshot.params['state'];
    }
    if (this.activatedRoute.snapshot.params['city']) {
      this.customer.city = this.activatedRoute.snapshot.params['city'];
    }
    if (this.activatedRoute.snapshot.params['address']) {
      this.customer.address = this.activatedRoute.snapshot.params['address'];
    }
    if (this.activatedRoute.snapshot.params['type']) {
      this.customer.jhiType = this.activatedRoute.snapshot.params['type'];
    }
    if (this.activatedRoute.snapshot.params['connector']) {
      this.customer.connector = this.activatedRoute.snapshot.params['connector'];
    }
    if (this.activatedRoute.snapshot.params['fieldActivity']) {
      this.customer.fieldActivity = this.activatedRoute.snapshot.params['fieldActivity'];
    }
    if (this.activatedRoute.snapshot.params['created_by']) {
      this.customer.created_by = this.activatedRoute.snapshot.params['created_by'];
    }
    if (this.activatedRoute.snapshot.params['employeeId']) {
      this.customer.employeeId = this.activatedRoute.snapshot.params['employeeId'];
    }
    if (this.activatedRoute.snapshot.params['fieldActivity']) {
      this.customer.fieldActivity = this.activatedRoute.snapshot.params['fieldActivity'];
    }

  }


  checkValue(event: any, id: any) {
    if (event.currentTarget.checked) {
      this.customersSelected.push(id);
    }

    if (!event.currentTarget.checked) {
      this.customersSelected = this.customersSelected.filter(item => item !== id);
    }
  }


  checkAllValue(event: any) {
    this.customersSelected = [];
    // alert(' in cehck all this.customers.length ===' + this.customers.length);
    if (event.currentTarget.checked) {
      this.customers.forEach((c) => {
        this.customersSelected.push(c.id);
        this.selectedBox = true;
        this.selectedAllBox = true;

      });
    }

    if (!event.currentTarget.checked) {
      this.customers.forEach((c) => {
        this.customersSelected = this.customersSelected.filter(item => item !== c.id);
        this.selectedBox = false;
        this.selectedAllBox = false;


      });
    }
  }


  save() {

    this.userService.find('parsa').subscribe(
      (res: HttpResponse<IUser>) => {
        this.user = res.body;
        this.user.customers = this.customersSelected;
        this.userService.update(this.user).subscribe(response => this.onSaveSuccess(response), (rej) => this.onSaveError(rej));
      });
  }


  private onSaveSuccess(result) {
  }

  private onSaveError(rej: any) {
  }


  loadAllUsers() {
    this.userService
      .queryCustomerFilter({
        page: 0,
        size: 100,
      })
      .subscribe(
        (res: HttpResponse<User[]>) => this.onSuccessUsers(res.body, res.headers),
        (res: HttpResponse<any>) => this.onError(res.body)
      );
  }

  assignUsers(val) {
    const modalRef = this.modalService.open(CustomerAssignUserDialogComponent, {windowClass: 'lg', backdrop: 'static'});
    modalRef.componentInstance.action = 'add';
    modalRef.componentInstance.type = val;
    modalRef.componentInstance.customerId = this.customer.id;
    modalRef.componentInstance.customersSelected = this.customersSelected;

    modalRef.result.then(
      res => {
        this.search(this.page, false);
      },
      rejected => {
        this.search(this.page, false);
      }
    );
  }


  assignUsersSingle(val) {
    const modalRef = this.modalService.open(CustomerAssignUserDialogComponent, {windowClass: 'lg', backdrop: 'static'});
    modalRef.componentInstance.action = 'add';
    modalRef.componentInstance.type = val;
    modalRef.componentInstance.customerId = val;
    modalRef.result.then(
      res => {
        this.search(this.page, false);
      },
      rejected => {
        this.search(this.page, false);
      }
    );
  }


  private onSuccessUsers(data, headers) {
    this.totalItems = headers.get('X-Total-Count');
    this.queryCount = this.totalItems;
    this.users = data;
  }


  ngOnInit() {
    this.loadAllFieldActivity();
    this.loadAllEmployee();
    this.loadAllConnector();
    this.getState();
    this.activatedRoute.params.subscribe((params) => {
      this.term = params['term'];
      this.search(this.page, true);

    })
    this.resetFormSubject.subscribe(response => {
      if(response){
        // yourForm.reset();i
        this.term;
        alert('uuuuuuuuuuuuuuuuuuu=='+this.term)
        // Or do whatever operations you need.
      }
    })
  }

  loadAll2() {
    this.fieldActivityService.query2().subscribe(
      (res: HttpResponse<any[]>) => {
        this.fieldActivities = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadAllEmployee() {
    this.employeeService.query().subscribe(
      (res: HttpResponse<IEmployee[]>) => {
        this.employees = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  loadAllFieldActivity() {
    this.fieldActivityService.query({
      page: 0,
      size: 10000,
      sort: ['itemName', 'asc']

    }).subscribe(
      (res: HttpResponse<IFieldActivity[]>) => {
        this.fieldActivities = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadAllMethod() {
    this.introductionService.query({
      page: 0,
      size: 10000,
      sort: ['itemName', 'asc']

    }).subscribe(
      (res: HttpResponse<IIntroduction[]>) => {
        this.introductions = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadAllConnector() {
    this.connectorService.query({
      page: 0,
      size: 10000,
      sort: ['itemName', 'asc']

    }).subscribe(
      (res: HttpResponse<IConnector[]>) => {
        this.connectors = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadAllOfficeWork() {
    this.departmentService.query({
      page: 0,
      size: 10000,
      sort: ['itemName', 'asc']

    }).subscribe(
      (res: HttpResponse<IDepartment[]>) => {
        this.departments = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  sort() {
    let result = ['id, desc'];
    if (this.predicate) {
      result = [this.predicate + ',' + this.reverse];
      return result;
    }
  }


  protected paginateCustomers(data: ICustomer[], headers: HttpHeaders, firstLoad) {
    this.totalItems_customer = headers.get('X-Total-Count');
    this.queryCount = this.totalItems_customer;

    this.start = ((this.page - 1) * this.itemsPerPage) + 1;
    const temp = this.totalItems_customer % this.itemsPerPage;
    this.pageCount = this.totalItems_customer / this.itemsPerPage;
    this.end = Number((this.page - 1) * this.itemsPerPage) + Number(this.itemsPerPage);

    if (temp > 0) {
      if (this.page <= (Math.round(this.pageCount) - 1)) {
        this.end = (Number(this.page - 1) * Number(this.itemsPerPage)) + Number(this.itemsPerPage);
      } else {
        if (this.itemsPerPage < this.totalItems_customer) {
          this.end = (Number(this.page - 1) * Number(this.itemsPerPage)) + Number(this.itemsPerPage);
        } else {
          this.end = Number((this.page - 1) * this.itemsPerPage) + Number(temp);

        }
      }
    } else {

      this.end = Number((this.page - 1) * this.itemsPerPage) + Number(this.itemsPerPage);

    }
    // alert(' 0000 end=='+this.end)

    // alert('(Number(this.end))='+((this.end)));
    // alert('(Number(this.totalItems_customer))='+((this.totalItems_customer)));
    if (((this.end)) > ((this.totalItems_customer))) {
      // alert(' in if ')
      this.end = this.totalItems_customer;
    }
    // alert(' end=='+this.end)

    // this.start = ((this.page - 1) *this.itemsPerPage) +1;
    // const temp = this.totalItems_customer % this.itemsPerPage;
    // this.pageCount = this.totalItems_customer /this.itemsPerPage;
    // this.end = ((this.page - 1) *this.itemsPerPage) +20;
    //
    // if(temp > 0) {
    //   if(this.page<=(Math.round(this.pageCount )-1)){
    //     this.end = ((this.page - 1) *this.itemsPerPage) +20;
    //   } else {
    //     this.end = ((this.page - 1) *this.itemsPerPage) +temp;
    //
    //   }
    // } else {
    //   this.end = ((this.page - 1) *this.itemsPerPage) +20;
    //
    // }


    this.customers = data;

    if (!firstLoad) {
      this.showSearchProfile();

    } else {
      this.spinner.hide();

    }
  }


  protected paginateCustomersExcel(data: ICustomerExcel[], headers: HttpHeaders) {
    this.totalItems_customer = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems_customer;
    this.customers = data;
    this.customerService.exportAsExcelFile(this.customers, 'customers');
    this.spinner.hide();
  }

  protected onError(errorMessage: string) {
  }


  open() {

    this.router.navigate(['/page/profile-customer']);

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }


  search(page, firstLoad) {

    if (page) {
      this.page = page;
    } else {
      this.page = 1;
    }


    this.selectedBox = false;
    this.selectedAllBox = false;
    this.spinner.show();
    let employeeId = -1;
    let employeeId_search = '';
    this.customersSelected = [];

    const span_actionDate = document.getElementById('span_actionDate');
    const span_actionDate_to = document.getElementById('span_actionDate_to');
    const span_actionDate_startDate = document.getElementById('span_actionDate_startDate');

    if (span_actionDate) {
      this.actionDate_from = (<HTMLInputElement>span_actionDate).innerHTML;
    }
    if (span_actionDate_to) {
      this.actionDate_to = (<HTMLInputElement>span_actionDate_to).innerHTML;
    }
    if (span_actionDate_startDate) {
      this.actionDate_startDate = (<HTMLInputElement>span_actionDate_startDate).innerHTML;
    }


    this.accountService.identity().then(account => {
      const type = (this.customer.jhiType ? this.customer.jhiType : '');
      const status = (this.customer.status ? this.customer.status : '');
      const created_by = (this.customer.created_by ? this.customer.created_by : '');
      const connector = (this.customer.connector ? this.customer.connector : '');
      const state = (this.customer.state ? this.customer.state : '');
      this.customer.title = this.term;
      const term = this.term;
      const title = (this.customer.title ? this.customer.title : '');
      const address = (this.customer.address ? this.customer.address : '');
      const city = (this.customer.city ? this.customer.city : '');
      const officeWork = (this.customer.officeWork ? this.customer.officeWork : '');
      const fieldActivity = (this.customer.fieldActivity ? this.customer.fieldActivity : '');
      const methodIntroduction = (this.customer.methodIntroduction ? this.customer.methodIntroduction : '');
      const nationalId = (this.customer.nationalId ? this.customer.nationalId : '');
      const economicCode = (this.customer.economicCode ? this.customer.economicCode : '');
      employeeId = (this.customer.employeeId ? this.customer.employeeId : '-1');
      employeeId_search = (this.customer.employeeId_search ? this.customer.employeeId_search : '');
      const actionDate_to = (this.actionDate_to ? this.actionDate_to : '');
      const actionDate_from = (this.actionDate_from ? this.actionDate_from : '');
      const actionDate_startDate = (this.actionDate_startDate ? this.actionDate_startDate : '');
      const deadline_days = (this.deadline_days ? this.deadline_days : '');
      const createdBy = (this.login ? this.login : '');
      let userId = 'null';
      const hasAnyAuthority = this.accountService.hasAuthority('ROLE_ADMIN');
      hasAnyAuthority.then(res => {
        if (res) {
          const userId = (this.userParam ? this.userParam : '');
          this.customerService
            .searchAdvanced({
              page: this.page - 1,
              size: this.itemsPerPage,
              sort: this.sort(),
              term,
              // status,
              // title,
              // city,
              // type,
              // officeWork,
              // fieldActivity,
              // methodIntroduction,
              // economicCode,
              // nationalId,
              // actionDate_to,
              // actionDate_from,
              // actionDate_startDate,
              // deadline_days,
              // userId,
              // address,
              // createdBy,
              // employeeId_search, created_by,
              // connector
            })
            .subscribe(
              (res: HttpResponse<ICustomer[]>) => this.paginateCustomers(res.body, res.headers, firstLoad),
              (res: HttpErrorResponse) => this.onError(res.message)
            );
        } else {
          userId = account.id;
          this.customerService
            .searchAdvanced({
              page: this.page - 1,
              size: this.itemsPerPage,
              sort: this.sort(),
              term,
              // status,
              // title,
              // city,
              // type,
              // officeWork,
              // fieldActivity,
              // methodIntroduction,
              // economicCode,
              // nationalId,
              // actionDate_to,
              // actionDate_from,
              // actionDate_startDate,
              // deadline_days,
              // userId,
              // address, createdBy,
              // employeeId,
              // connector, created_by
            })
            .subscribe(
              (res: HttpResponse<ICustomer[]>) => this.paginateCustomers(res.body, res.headers, firstLoad),
              (res: HttpErrorResponse) => this.onError(res.message)
            );

        }
      });
    });
  }


  loadExport() {
    // alert(' in loadExport');
    const employeeId = 1;
    this.customers_excel = this.customers;
    this.customerService.exportAsExcelFile(this.customers_excel, 'customers');
    this.spinner.hide();

    // this.accountService.identity().then(account => {
    //   const type = (this.customer.jhiType ? this.customer.jhiType : '');
    //   const status = (this.customer.status ? this.customer.status : '');
    //   const state = (this.customer.state ? this.customer.state : '');
    //   const title = (this.customer.title ? this.customer.title : '');
    //   const city = (this.customer.city ? this.customer.city : '');
    //   const officeWork = (this.customer.officeWork ? this.customer.officeWork : '');
    //   const fieldActivity = (this.customer.fieldActivity ? this.customer.fieldActivity : '');
    //   const methodIntroduction = (this.customer.methodIntroduction ? this.customer.methodIntroduction : '');
    //   this.customerService
    //     .search({
    //       page: this.page - 1,
    //       size: 1000,
    //       sort: this.sort(),
    //       state,
    //       status,
    //       title,
    //       city,
    //       type,
    //       officeWork,
    //       fieldActivity,
    //       methodIntroduction
    //     })
    //     .subscribe(
    //       (res: HttpResponse<ICustomerExcel[]>) => this.paginateCustomersExcel(res.body, res.headers),
    //       (res: HttpErrorResponse) => this.onError(res.message)
    //     );
    // });
  }


  sort_2() {
    const result = [this.predicate + ',' + (this.reverse)];
    if (this.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }

  loadPage(page: number) {
    if (page !== this.previousPage) {
      this.previousPage = page;
      this.transition(page);
    }
  }


  loadPage2(param) {
    this.page = 1;
    if (this.predicate === param) {
      if (this.reverse === 'asc') {
        this.reverse = 'desc';
      } else {
        this.reverse = 'asc';
      }
    } else {
      this.reverse = 'asc';
    }
    this.predicate = param;
    this.transition(this.page);
  }


  transition(page) {
    // alert(' in transition ==' + page);
    this.search(page, false);
  }


  getState() {
    const state = this.customer.state;
    this.customerService
      .getStates({
        page: 0,
        size: 500,
        state,

      })
      .subscribe(
        (res: HttpResponse<IStateCity[]>) => this.onSuccessState(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }


  protected onSuccessState(data: IStateCity[], headers: HttpHeaders) {
    this.stateList = data;
    if (this.customer && this.customer != null && this.customer.state && this.customer.state != null) {
      this.getCity();
    }

  }

  getCity() {
    const state = this.customer.state;
    this.customerService
      .getCities({
        page: 0,
        size: 500,
        state,
      })
      .subscribe(
        (res: HttpResponse<IStateCity[]>) => this.onSuccessCity(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    this.search(this.page, false);
  }


  protected onSuccessCity(data: IStateCity[], headers: HttpHeaders) {
    this.cityList = data;
  }


  parseDate(value) {
    let jalaliDate5 = '-';
    if (value) {
      jalaliDate5 = moment(value).locale('fa').format('jYYYY/jM/jD');
    } // 1367/11/4
    return jalaliDate5;
  }

  parseDate_tehran(value) {
    let jalaliDate5 = '-';
    if (value) {
      jalaliDate5 = moment(new Date(value)).locale('fa').format('jYYYY/jM/jD');
    } // 1367/11/4
    return jalaliDate5;
  }


  percentCellRenderer(value, status, status_2) {
    const today = new Date();
    const dateExpiration = new Date(value + '');
    let timeDiff = (dateExpiration.getTime() - today.getTime());
    if (dateExpiration.getTime < today.getTime) {
      timeDiff = -1 * timeDiff;
    }
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    value = diffDays;
    const valueNumber = Number(value + '');
    let valueStr = '';
    const eDivPercentBar = document.createElement('div');
    eDivPercentBar.className = '';
    const eValue = document.createElement('div');
    valueStr = 'Expired';

    eValue.className = 'progress-bar progress-bar-striped bg-primary';

    if (status_2 && status_2 === 'completed') {
      valueStr = 'بررسی شد.';
      eValue.style.width = '100%';
      eValue.style.paddingLeft = '1px';
      eValue.style.color = 'green';

    } else {
      if (valueNumber < 0) {
        eValue.style.width = '100%';
        eValue.className = 'progress-bar progress-bar-striped bg-danger';
        valueStr = '' + Math.abs(value) + ' روز گذشته';
      } else if (valueNumber === 0) {
        eValue.style.width = '100%';
        eValue.className = 'progress-bar progress-bar-striped bg-danger';
        valueStr = '' + Math.abs(value) + ' روز مانده';
      } else if (valueNumber < 30 && valueNumber > 0) {
        eValue.style.width = '80%';
        valueStr = value + ' روز';
        eValue.className = 'progress-bar progress-bar-striped bg-warning';
      } else if (valueNumber < 60 && valueNumber > 0) {
        eValue.style.width = '60%';
        valueStr = value + ' روز';
        eValue.className = 'progress-bar progress-bar-striped bg-info';
      } else if (valueNumber < 90 && valueNumber > 0) {
        valueStr = value + ' روز';
        eValue.style.width = '40%';
        eValue.className = 'progress-bar progress-bar-striped bg-succsess';
      } else if (isNaN(valueNumber)) {
        if (status && status === 'Optional') {
          // alert(status);
          valueStr = 'بدون مهلت';
          eValue.style.width = '1%';
          eValue.style.paddingLeft = '1px';
          eValue.style.color = 'red';
        } else {
          valueStr = 'Not Uploaded';
          eValue.style.width = '1%';
          eValue.style.paddingLeft = '1px';
          eValue.style.color = 'red';
        }
        eValue.className = 'progress-bar progress-bar-striped bg-primary';
      } else {
        eValue.style.width = '45%';
        valueStr = value + ' روز';
        eValue.className = 'progress-bar progress-bar-striped bg-primary';
      }
    }
    const eOuterDiv = document.createElement('div');
    eOuterDiv.className = 'progress mb-2';
    eOuterDiv.style.marginTop = '12px';
    eOuterDiv.appendChild(eValue);
    const re = /&lt;/gi;
    const re2 = /&gt;/gi;
    const str = eOuterDiv.outerHTML;
    const newstr = str.replace(re, '<').replace(re2, '>');
    const newstr2 = str.replace(re, '>');
    return valueStr;
  }


  styleObject(value, status, status_2): Object {
    const today = new Date();

    const dateExpiration = new Date(value + '');
    let timeDiff = (dateExpiration.getTime() - today.getTime());
    if (dateExpiration.getTime < today.getTime) {
      timeDiff = -1 * timeDiff;
    }
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    value = diffDays;
    const valueNumber = Number(value + '');

    if (status_2 && status_2 === 'completed') {
      this.width = '100%';
      return {width: this.width, 'background-color': '#168016'};

    } else {

      if (valueNumber <= 0) {
        this.width = '100%';
        return {width: this.width, 'background-color': '#dc3545'};
      } else if (valueNumber < 30 && valueNumber > 0) {
        this.width = '80%';
        return {width: this.width, 'background-color': '#ffc107'};
      } else if (valueNumber < 60 && valueNumber > 0) {
        this.width = '60%';
        return {width: this.width, 'background-color': '#17a2b8'};
      } else if (valueNumber < 90 && valueNumber > 0) {
        this.width = '40%';
        return {width: this.width, 'background-color': '#007bff'};
      } else if (isNaN(valueNumber)) {
        if (status && status === 'Optional') {
          this.width = '1%';
          return {'color': '#dc3545', paddingLeft: '1px', 'background-color': '#eaeaea'};
        } else {
          this.width = '1%';
          return {'color': '#dc3545', paddingLeft: '1px', 'background-color': '#eaeaea'};
        }
      } else {
        this.width = '45%';
        return {width: this.width, 'background-color': '#007bff'};
      }
    }
  }

  classObject() {
    const thisClass = 'progress-bar progress-bar-striped bg-primary';
    return {thisClass};
  }

  public showProfile(data) {
    this.customerSearch = this.customer;
    this.router.navigate(['page/profile-customer/', data]);
  }

  public showSearchProfile() {
    this.customerSearch = this.customer;
    // this.router.navigate(['page/rapid-search/'+this.term,
    //   {
    //     page: this.page,
    //     predicate: this.predicate,
    //     reverse: this.reverse,
    //     customer: (this.customer.title ? this.customer.title : ''),
    //     status: (this.customer.status ? this.customer.status : ''),
    //     state: (this.customer.state ? this.customer.state : ''),
    //     city: (this.customer.city ? this.customer.city : ''),
    //     address: (this.customer.address ? this.customer.address : ''),
    //     type: (this.customer.jhiType ? this.customer.jhiType : ''),
    //     employeeId: (this.customer.employeeId_search ? this.customer.employeeId_search : ''),
    //     created_by: (this.customer.created_by ? this.customer.created_by : ''),
    //     fieldActivity: (this.customer.fieldActivity ? this.customer.fieldActivity : ''),
    //     connector: (this.customer.connector ? this.customer.connector : ''),
    //     actionDate_to: (this.actionDate_to ? this.actionDate_to : ''),
    //     actionDate_from: (this.actionDate_from ? this.actionDate_from : ''),
    //     deadline_days: (this.deadline_days ? this.deadline_days : ''),
    //   }]);
    this.spinner.hide();

  }


  openSearchPhone() {
    this.modalService.open(PhoneSearchComponent, {windowClass: 'lg', backdrop: 'static'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  goToAdd() {
    this.router.navigate(['/page/profile-customer/new']);

  }

  openRapidForm(val) {
    const modalRef = this.modalService.open(CustomerAddRapidComponent, {windowClass: 'sm', backdrop: 'static'});
    modalRef.componentInstance.type = val;
    modalRef.result.then(res => {
      console.log(res + ' the result of popup');
    }, rejected => {
      console.log(' rejected: ' + rejected.toString());
    });
  }


  openOrderForm() {
    this.modalService.open(OrderAddComponent, {windowClass: 'sm', backdrop: 'static'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }


  searchCustomer() {
    this.modalService.open(CustomerAdvancedSearchComponent, {
      windowClass: 'sm',
      backdrop: 'static'
    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  playAudio() {
    // Disabled with app-root ding audio (was triggering downloads)
    // const script: HTMLAudioElement = <HTMLAudioElement>document.getElementsByTagName('audio')[0];
    // if (script) { script.play(); }
    // this.showToaster('2072');
  }

  showToaster(id) {
    const dr = ' برای شما یک پیگیری جدید ثبت شده ';
    this.toastr.success(dr, 'پیام جدید!', {
      timeOut: 0,
      extendedTimeOut: 0,
      tapToDismiss: true,
      closeButton: true,
      // tapToDismiss: true
      // toastComponent: CustomComponent
    })
      .onTap
      .pipe(take(1))
      .subscribe(() => this.toasterClickedHandler(id));
  }

  toasterClickedHandler(id) {
    console.log('Toastr clicked');

    this.router.navigate(['/page/profile-customer-project/' + id + '/project']);
    // this.clear();

  }
}
